__turbopack_context__.v({
  "specials_list": "SpecialsTab-module-scss-module__hpxPHa__specials_list",
  "specials_tab": "SpecialsTab-module-scss-module__hpxPHa__specials_tab",
});
